module.exports = __webpack_public_path__ + "img/6.a62162e0.jpg";